// TODO - Type 'any' needs to be fixed.
/* eslint-disable no-mixed-spaces-and-tabs */

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import {
	Alert,
	AlertTitle,
	Autocomplete,
	Box,
	Button,
	CircularProgress,
	FormControl,
	IconButton,
	InputAdornment,
	MenuItem,
	Tooltip,
	Typography,
} from "@mui/material";
import { TextField as MUITextField } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers-pro-6";
import { AdapterDateFns } from "@mui/x-date-pickers-pro-6/AdapterDateFns";
import { AdapterDayjs } from "@mui/x-date-pickers-pro-6/AdapterDayjs";
import { format, isValid, parseISO } from "date-fns";
import * as dateFns from "date-fns";
import dayjs from "dayjs";
import { Field } from "formik";
import { TextField } from "formik-mui";
import { useConfirm } from "material-ui-confirm";
import React, {
	forwardRef,
	useCallback,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { colors } from "../../../../../../export/config";
import {
	cancelFuturePatternChange,
	closeAddWorkerDialog,
	getLocationShiftPatterns,
	resetCancelFuturePatternChange,
	setIsBadgeNumberUnique,
	setIsEmployeeIdUnique,
} from "../../../../../../export/workers";
import {
  PhoneTextField,
  SchedulePatternChangeDialog,
  ShiftPatternDialog,
} from "../../../../../../export/workers";
import { SETTINGS_PERMISSIONS } from "../../../../../config/permissions";
import JobColor from "../../../../../design/ui/job-color";
import {
	deCamelCase,
	formatDate,
	hasPermissionString,
} from "../../../../../utils/helpers";
import ConfirmDialog from "../../../../ConfirmDialog";
import Highlight from "../../../../Highlight";
import useShiftPatternMenupropsController from "../../../controllers/use-shift-pattern-menuprops-controller";
import useWorkersData from "../../../controllers/use-workers-data";

interface Supervisor {
	id: string;
	firstName: string;
	lastName: string;
	isActive: boolean;
	roles: {
		name: string;
	}[];
}

interface WorkerSubType {
	id: number;
	name: string;
	description?: string;
	isActive?: boolean;
}

const useStyles = makeStyles(() => ({
	formRoot: {
		width: "100%",
	},
	formControlRoot: {
		width: "100%",
		backgroundColor: colors.light,
	},
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

interface WorkerDetailFormProps {
	values: any;
	setFieldValue: (field: string, value: any) => void;
	setFieldTouched: (field: string, touched: boolean, shouldValidate?: boolean) => void;
	isActive: boolean;
	handleNext: () => void;
	isValid: boolean;
	existingWorkers: any[];
	workerTypes: any[];
	allLocations: any[];
	userLocations: any[];
	getWorkerType: (id: number) => any;
	checkWorkerIdAlreadyExists: (value: any) => void;
	checkBadgeNumberAlreadyExists: (
		badgeNumber: string,
		locationId: number
	) => void;
	isSubmitting: boolean;
	dirty: boolean;
	isEditing: boolean;
	setActiveStep: (step: number) => void;
	errors: any;
	touched: any;
	allJobRoles: any[];
}

const isNumber = new RegExp(/^[0-9]*$/);

const WorkerDetailForm = forwardRef<HTMLDivElement, WorkerDetailFormProps>(
	function WorkerDetailForm(props, ref) {
		const {
			values,
			setFieldValue,
			setFieldTouched,
			isActive,
			handleNext,
			isValid,
			existingWorkers,
			workerTypes,
			userLocations,
			getWorkerType,
			checkWorkerIdAlreadyExists,
			checkBadgeNumberAlreadyExists,
			isSubmitting,
			dirty,
			isEditing,
			setActiveStep,
			errors,
			touched,
			allJobRoles,
		} = props;
		const classes = useStyles();
		const dispatch = useDispatch();
		const { t } = useTranslation();

		const WORKER_ID_AVAILABLE = t("workers_worker-id-available");
		const BADGE_NUMBER_AVAILABLE = t("workers_badge-number-available");

		const { myElementRef, position } = useShiftPatternMenupropsController();

		const {
			locationShiftPatterns,
			getLocationShiftPatternStatus,
			allSupervisors,
			createNewWorkerStatus,
			createNewWorkerErrorMessage,
			editWorkerStatus,
			editWorkerErrorMessage,
			isEmployeeIdUniqueStatus,
			isEmployeeIdUniqueData,
			isBadgeNumberUniqueData,
			isBadgeNumberUniqueStatus,
			workerSubTypes,
			isWorkerSubTypeEnabled,
			badgeNumberEnabled,
			badgeNumberEnabledLocations,
			workerStatuses,
			workerProfile,
			cancelFuturePatternChangeStatus,
			permissions,
			workerFilters,
		} = useWorkersData();

		const canEditWorker = hasPermissionString(
			permissions,
			SETTINGS_PERMISSIONS.WORKERS.EDIT
		);

		const [lastSelectedLocationId, setLastSelectedLocationId] = useState(
			values.locationId ?? ""
		);

		const [selectedShiftPattern, setSelectedShiftPattern] = useState<any>({});
		const [isShiftPatternOpen, setIsShiftPatternOpen] = useState(false);
		const [isSchedulePatternChangeOpen, setIsSchedulePatternChangeOpen] =
			useState(false);
		const [isPendingScheduleConfirmOpen, setIsPendingScheduleConfirmOpen] =
			useState(false);
		const [pendingLocationValue, setPendingLocationValue] = useState<any>(null);
		const [pendingScheduleConfirmText, setPendingScheduleConfirmText] =
			useState("");

		const openSchedulePatternChange = () => {
			setIsSchedulePatternChangeOpen(true);
		};

		const closeSchedulePatternChange = () => {
			setIsSchedulePatternChangeOpen(false);
		};

		const handleCancelPatternChange = () => {
			if (workerProfile?.workerId) {
				dispatch(cancelFuturePatternChange({ workerId: workerProfile.workerId }));
			}
		};

		// Badge Number helper text
		const getBadgeNumberHelperText = () => {
			try {
				const badgeNumber = values.badgeNumber;

				const isBadgeNumberChecked = isBadgeNumberUniqueData?.checked;
				const isBadgeNumberUnique = isBadgeNumberUniqueData?.isUnique;
				const isBadgeNumberSame =
					isBadgeNumberUniqueData?.originalBadgeNumber &&
					isBadgeNumberUniqueData?.originalBadgeNumber?.toString() !==
						badgeNumber.toString();
				const doesBadgeNumberMatch =
					isBadgeNumberUniqueData?.badgeNumber?.toString() ===
					badgeNumber.toString();
				const isBadgeNumberProvided = badgeNumber.length > 0;

				let helperText = "";

				if (isBadgeNumberSame) {
					if (
						isBadgeNumberProvided &&
						doesBadgeNumberMatch &&
						!isBadgeNumberUnique &&
						isBadgeNumberChecked
					) {
						helperText = t("workers_badge-number-already-exists");
					} else if (!isBadgeNumberChecked) {
						helperText = "";
					} else {
						helperText = BADGE_NUMBER_AVAILABLE;
					}
				}

				return helperText;
			} catch (e) {
				return "";
			}
		};

		// Badge Number end adornment
		const getBadgeNumberEndAdornment = () => {
			try {
				const isPending = isBadgeNumberUniqueStatus === "pending";
				const isBadgeNumberEmpty = values.badgeNumber === "";
				const isBadgeNumberChecked = isBadgeNumberUniqueData.checked;
				const showCheckIcon =
					!isPending &&
					!getBadgeNumberError() &&
					!isBadgeNumberEmpty &&
					isBadgeNumberChecked &&
					isBadgeNumberUniqueData?.originalBadgeNumber !== values.badgeNumber;
				const showButton =
					!isPending &&
					!getBadgeNumberError() &&
					!isBadgeNumberEmpty &&
					!isBadgeNumberChecked;

				if (showButton) {
					checkBadgeNumberAlreadyExists(values.badgeNumber, values.locationId);
				}

				return (
					<InputAdornment position='end'>
						{isPending ? (
							<CircularProgress size={20} />
						) : showCheckIcon ? (
							<CheckCircleIcon sx={{ color: "#2E7D32" }} />
						) : null}
					</InputAdornment>
				);
			} catch (e) {
				return <></>;
			}
		};
		// BadgeNumber error
		const getBadgeNumberError = () => {
			try {
				const errorInBadgeNumber = errors.badgeNumber !== undefined;
				const badgeNumber = values.badgeNumber;
				const isBadgeNumberChecked = isBadgeNumberUniqueData?.checked;
				const isBadgeNumberUnique = isBadgeNumberUniqueData?.isUnique;
				const doesBadgeNumberMatch =
					isBadgeNumberUniqueData?.badgeNumber === badgeNumber;
				const isBadgeNumberProvided = badgeNumber.length > 0;
				const isBadgeNumberDuplicate =
					isBadgeNumberProvided &&
					doesBadgeNumberMatch &&
					!isBadgeNumberUnique &&
					isBadgeNumberChecked;

				return errorInBadgeNumber || isBadgeNumberDuplicate;
			} catch (e) {
				return false;
			}
		};

		// WorkerId helper text
		const getWorkerIdHelperText = () => {
			try {
				const workerId = values.companyEmployeeId;

				const isWorkerIdChecked = isEmployeeIdUniqueData?.checked;
				const isWorkerIdUnique = isEmployeeIdUniqueData?.isUnique;
				const isWorkerIdSame =
					isEmployeeIdUniqueData?.originalEmployeeId !== workerId;
				const doesWorkerIdMatch =
					isEmployeeIdUniqueData?.employeeId === workerId;
				const isWorkerIdProvided = workerId.length > 0;

				let helperText = "";

				if (isWorkerIdSame) {
					if (
						isWorkerIdProvided &&
						doesWorkerIdMatch &&
						!isWorkerIdUnique &&
						isWorkerIdChecked
					) {
						helperText = t("workers_worker-id-already-exists");
					} else if (!isWorkerIdChecked) {
						helperText = "";
					} else {
						helperText = WORKER_ID_AVAILABLE;
					}
				}

				return helperText;
			} catch (e) {
				return "";
			}
		};

		// WorkerId end adornment
		const getWorkerIdEndAdornment = () => {
			try {
				const isPending = isEmployeeIdUniqueStatus === "pending";
				const isWorkerIdEmpty = values.companyEmployeeId === "";
				const isWorkerIdChecked = isEmployeeIdUniqueData.checked;
				const showCheckIcon =
					!isPending &&
					!getWorkerIdError() &&
					!isWorkerIdEmpty &&
					isWorkerIdChecked &&
					isEmployeeIdUniqueData.originalEmployeeId !==
						values.companyEmployeeId;
				const showButton =
					!isPending &&
					!getWorkerIdError() &&
					!isWorkerIdEmpty &&
					!isWorkerIdChecked;

				if (showButton) {
					checkWorkerIdAlreadyExists(values.companyEmployeeId);
				}

				return (
					<InputAdornment position='end'>
						{isPending ? (
							<CircularProgress size={20} />
						) : showCheckIcon ? (
							<CheckCircleIcon sx={{ color: "#2E7D32" }} />
						) : null}
					</InputAdornment>
				);
			} catch (e) {
				return <></>;
			}
		};
		// WorkerId error
		const getWorkerIdError = () => {
			try {
				const errorInWorkerId = errors.companyEmployeeId !== undefined;
				const workerId = values.companyEmployeeId;
				const isWorkerIdChecked = isEmployeeIdUniqueData?.checked;
				const isWorkerIdUnique = isEmployeeIdUniqueData?.isUnique;
				const doesWorkerIdMatch =
					isEmployeeIdUniqueData?.employeeId === workerId;
				const isWorkerIdProvided = workerId.length > 0;
				const isWorkerIdDuplicate =
					isWorkerIdProvided &&
					doesWorkerIdMatch &&
					!isWorkerIdUnique &&
					isWorkerIdChecked;

				return errorInWorkerId || isWorkerIdDuplicate;
			} catch (e) {
				return false;
			}
		};

		const openShiftPattern = () => {
			setIsShiftPatternOpen(true);
		};

		const closeShiftPattern = () => {
			setIsShiftPatternOpen(false);
		};

		// Read Only users can't be reporting managers, active or not. Inactive
		// users stay so an edited worker's current supervisor still shows.
		const companySupervisors = allSupervisors.filter(
			(obj: Supervisor) =>
				!obj.roles.some((role: { name: string }) => role.name === "ReadOnly")
		);

		// Build the location list (with each location's work centers) from the
		// filter API (GetFiltersForUser) rather than the separate
		// companies/{id}/locations master-data call. That call can still be in
		// flight when this form opens, which left the Work Center dropdown blank;
		// the filter data is already loaded for the workers page, so work centers
		// are available immediately.
		const allLocations = useMemo(() => {
			const workcenters = workerFilters?.allWorkcenters ?? [];
			return (workerFilters?.allLocations ?? []).map((location: any) => ({
				...location,
				workCenters: workcenters.filter(
					(wc: any) => wc.locationId === location.id
				),
			}));
		}, [workerFilters?.allLocations, workerFilters?.allWorkcenters]);

		const locationWorkcenters = useMemo(() => {
			return (
				allLocations.find((location: any) => location.id === values.locationId)
					?.workCenters ?? []
			);
		}, [allLocations, values?.locationId]);

		useEffect(() => {
			if (values.shiftPatternId && locationShiftPatterns.length > 0) {
				const pattern = locationShiftPatterns.find(
					(pattern: { id: any }) => pattern.id === values.shiftPatternId
				);
				setSelectedShiftPattern(pattern);
			}
		}, [values.shiftPatternId, locationShiftPatterns]);

		const confirm = useConfirm();

		const isUserLocation = useCallback(
			(id: string) => {
				let returnValue = false;
				if (userLocations) {
					if (userLocations.length > 0) {
						userLocations.forEach((location) => {
							if (Object.prototype.hasOwnProperty.call(location, "id")) {
								if (parseInt(location.id) === parseInt(id)) {
									returnValue = true;
								}
							}
						});
					}
				}
				return returnValue;
			},
			[userLocations]
		);

		const checkPhoneAlreadyExists = (value: string) => {
			try {
				const foundWorker = existingWorkers.filter(
					(worker) => worker.phoneNumber === value
				);
				return foundWorker.length > 0;
			} catch (e) {
				return false;
			}
		};

		const getSelectedLocation = useCallback(
			(forId = "") => {
				let returnValue = null;
				const id = forId !== "" ? forId : values.locationId;
				if (id && allLocations && allLocations.length > 0) {
					allLocations.forEach((location) => {
						if (parseInt(id) === parseInt(location.id)) {
							returnValue = location;
						}
					});
				}
				return returnValue;
			},
			[allLocations, values.locationId]
		);

		const getSelectedWorkcenter = useCallback(
			(forId = "") => {
				let returnValue = null;
				const id = forId !== "" ? forId : values.workCenterId;
				if (id && locationWorkcenters && locationWorkcenters.length > 0) {
					locationWorkcenters?.forEach((wc: { id: string }) => {
						if (parseInt(id) === parseInt(wc.id)) {
							returnValue = wc;
						}
					});
				}
				return returnValue;
			},
			[locationWorkcenters, values.workCenterId]
		);

		const getSelectedSupervisor = useCallback(
			(forId = "") => {
				let returnValue = null;
				const id = forId !== "" ? forId : values.managerUserId;
				if (id && companySupervisors && companySupervisors.length > 0) {
					companySupervisors.forEach((supervisor: Supervisor) => {
						if (parseInt(id) === parseInt(supervisor.id)) {
							returnValue = supervisor;
						}
					});
				}
				return returnValue;
			},
			[companySupervisors, values.managerUserId]
		);

		const getJobsByWorkCenter = useCallback(
			(workCenterId: string) => {
				const returnValue: any = [];
				if (workCenterId && allJobRoles && allJobRoles.length > 0) {
					allJobRoles.forEach((job: any) => {
						const workCenterIds = job.workCenterIds.split(",");
						if (workCenterIds.includes(workCenterId.toString())) {
							returnValue.push(job);
						}
					});
				}
				return returnValue;
			},
			[allJobRoles]
		);
		// console.log("getJobsByWorkCenter",getJobsByWorkCenter(values?.workCenterId));

		const getSelectedJobRole = useCallback(() => {
			let returnValue = null;
			const id = values.primaryJobId;
			if (id && allJobRoles && allJobRoles.length > 0) {
				allJobRoles.forEach((job: any) => {
					if (parseInt(id) === parseInt(job.id)) {
						returnValue = job;
					}
				});
			}
			return returnValue;
		}, [allJobRoles, values.primaryJobId]);

		const getPendingScheduleConfirmText = useCallback(
			(pendingLocation: any) => {
				if (!workerProfile?.pendingPatternChange) return "";

				const { shiftPatternName, effectiveDate } =
					workerProfile.pendingPatternChange;
				const patternName = shiftPatternName;
				const date = formatDate({
					dateStr: effectiveDate,
					formatType: "NUMERIC_DATE",
					ISOString: false,
				});

				if (pendingLocation) {
					const isDifferentFromUserLocation =
						!isUserLocation(pendingLocation.id) &&
						parseInt(lastSelectedLocationId) !== parseInt(pendingLocation.id);

					if (isDifferentFromUserLocation) {
						const location = getSelectedLocation(lastSelectedLocationId) ?? {
							name: "",
						};
						return t(
							"workers_pending-schedule-request-confirm-location-different",
							{
								patternName,
								date,
								firstName: values.firstName,
								lastName: values.lastName,
								locationName: pendingLocation.name,
								currentLocation: location.name,
							}
						);
					}
					return t("workers_pending-schedule-request-confirm-location", {
						patternName,
						date,
						locationName: pendingLocation.name,
					});
				}

				return t("workers_pending-schedule-request-confirm", {
					patternName,
					date,
				});
			},
			[
				workerProfile?.pendingPatternChange,
				isUserLocation,
				lastSelectedLocationId,
				getSelectedLocation,
				values.firstName,
				values.lastName,
				t,
			]
		);

		const handleLocationUpdate = useCallback(
			(value: any, skipConfirm = false) => {
				const proceedWithUpdate = () => {
					setLastSelectedLocationId(value.id);
					setTimeout(() => {
						setFieldValue("locationId", value.id);
					}, 100);
					setFieldValue("shiftPatternId", 0);
					if (value.id !== values.locationId) {
						const allWorkCentersForLocation =
							allLocations.find((location) => location.id === value.id)
								?.workCenters ?? [];
						const accessibleWCIds = (workerFilters?.allWorkcenters ?? []).map(
							(wc: any) => wc.id
						);
						const newWorkCenters = allWorkCentersForLocation.filter(
							(wc: any) => accessibleWCIds.includes(wc.id)
						);
						if (newWorkCenters.length > 0) {
							setFieldValue("workCenterId", newWorkCenters[0].id);
						} else {
							setFieldValue("workCenterId", undefined);
						}
					}
					setSelectedShiftPattern({});
					setFieldValue("primaryJobId", 0);
				};

				if (
					!skipConfirm &&
					!isUserLocation(value.id) &&
					parseInt(lastSelectedLocationId) !== parseInt(value.id)
				) {
					if (parseInt(value.id) !== parseInt(values.id)) {
						const location = getSelectedLocation(lastSelectedLocationId) ?? {
							name: "",
						};
						confirm({
							title: t("workers_confirm-proceed-title"),
							description: t("workers_change-location-confirm", {
								firstName: values.firstName,
								lastName: values.lastName,
								locationName: value.name,
								currentLocation: location.name,
							}),
						})
							.then(() => {
								proceedWithUpdate();
							})
							.catch(() => {
								/* ... */
							});
					}
				} else {
					proceedWithUpdate();
				}
			},
			[
				isUserLocation,
				lastSelectedLocationId,
				values.id,
				getSelectedLocation,
				confirm,
				values.firstName,
				values.lastName,
				setFieldValue,
				values.locationId,
				allLocations,
				setSelectedShiftPattern,
				setLastSelectedLocationId,
				workerFilters,
				t,
			]
		);

		useEffect(() => {
			if (
				isPendingScheduleConfirmOpen &&
				cancelFuturePatternChangeStatus === "fulfilled"
			) {
				setIsPendingScheduleConfirmOpen(false);
				if (pendingLocationValue) {
					handleLocationUpdate(pendingLocationValue, true);
					setPendingLocationValue(null);
				}
				dispatch(resetCancelFuturePatternChange());
			}
		}, [
			cancelFuturePatternChangeStatus,
			handleLocationUpdate,
			isPendingScheduleConfirmOpen,
			pendingLocationValue,
			dispatch,
		]);

		useEffect(() => {
			if (values.locationId && getWorkerType(values.workerTypeId).name !== "FlexWorker") {
				const locationId = values.locationId;
				dispatch(getLocationShiftPatterns({ locationId }));
			}
		}, [values.locationId, values.workerTypeId, getWorkerType, dispatch]);

		const combineWorkerTypes = (workerTypes: any[], workerSubTypes: any[]) => {
			return workerTypes.map((type) => ({
				...type,
				subtypes: workerSubTypes
					.filter((subtype) => subtype.workerTypeId === type.id)
					.map((subtype) => ({
						id: subtype.id,
						name: subtype.name,
						description: subtype.description,
						isActive: subtype.isActive,
					})),
			}));
		};
		const combinedWorkerTypes = combineWorkerTypes(workerTypes, workerSubTypes);

		return (
			<Box
				sx={{
					borderRadius: "10px",
					border: isActive ? "2px solid #2F4D8B" : "3px solid #f4f4f4",
					pointerEvents: isActive ? "auto" : "none",
				}}
				ref={ref}
			>
				<Box p={2}>
					<Typography fontWeight='bold'>{t("workers_basic-details")}</Typography>
					<Typography variant='caption'>
						{/* Add in workers personal information. */}
					</Typography>
					<Box
						display='flex'
						justifyContent='flex-start'
						flexWrap='wrap'
						mt={2}
						sx={{
							minHeight: "80px",
						}}
					>
						<Box mr={3} width={300}>
							<FormControl variant='filled' className={classes.formControlRoot}>
								<Field
									component={TextField}
									name='firstName'
									id='firstName'
									type='text'
									label={t("workers_first-name")}
									variant='filled'
									InputLabelProps={{
										shrink: true,
									}}
									margin='dense'
								/>
							</FormControl>
						</Box>
						<Box width={300}>
							<FormControl variant='filled' className={classes.formControlRoot}>
								<Field
									component={TextField}
									name='lastName'
									id='lastName'
									type='text'
									label={t("workers_last-name")}
									variant='filled'
									InputLabelProps={{
										shrink: true,
									}}
									margin='dense'
								/>
							</FormControl>
						</Box>
					</Box>
					<Box
						display='flex'
						justifyContent='flex-start'
						flexWrap='wrap'
						mt={2}
						sx={{
							minHeight: "80px",
						}}
					>
						<Box mr={3} width={240}>
							<FormControl>
								<PhoneTextField
									values={values}
									setFieldValue={setFieldValue}
									checkPhoneAlreadyExists={checkPhoneAlreadyExists}
								/>
							</FormControl>
						</Box>
						<Box ml={7.5} mt={1} mr={3} width={300}>
							<Field
								component={TextField}
								name='email'
								id='email'
								type='email'
								label={t("workers_email-optional")}
								variant='filled'
								// value={values.email}
								InputLabelProps={{
									shrink: true,
								}}
								validate={(value: string) => {
									if (!value) {
										return "";
									} else if (
										!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
									) {
										return t("workers_invalid-email-address");
									}
								}}
								helperText=''
								sx={{ width: "100%" }}
							/>
						</Box>
					</Box>
					<Box
						display='flex'
						justifyContent='flex-start'
						flexWrap='wrap'
						mt={2}
						sx={{
							minHeight: "80px",
						}}
					>
						{userLocations && userLocations.length > 0 && (
							<Box mr={3} width={300}>
								<Autocomplete
									disableClearable
									renderInput={(params) => (
										<MUITextField
											{...params}
											variant='filled'
											label={t("workers_location")}
											InputLabelProps={{
												shrink: true,
											}}
										/>
									)}
									value={getSelectedLocation()}
									options={userLocations}
									isOptionEqualToValue={(option, value) =>
										String(option.id) === String(value.id)
									}
									getOptionLabel={(option) => option.name}
									onChange={(_event, value) => {
										if (workerProfile?.pendingPatternChange) {
											setPendingLocationValue(value);
											setPendingScheduleConfirmText(
												getPendingScheduleConfirmText(value)
											);
											setIsPendingScheduleConfirmOpen(true);
											return;
										}
										handleLocationUpdate(value);
									}}
									renderOption={(props, option, { inputValue }) => (
										<li {...props} key={option.id}>
											<Box
												sx={{
													display: "flex",
													flexDirection: "row",
													alignItems: "center",
													justifyContent: "flex-start",
													minHeight: "32px",
												}}
											>
												<Typography
													sx={{
														fontFamily: "Roboto",
														fontSize: "14px !important",
														color: "rgba(0,0,0,0.87) !important",
														lineHeight: "20px !important",
														fontWeight: 400,
													}}
												>
													<Highlight
														value={option.name}
														searchText={inputValue}
													/>
												</Typography>
											</Box>
										</li>
									)}
								/>
							</Box>
						)}
						{locationWorkcenters && (
							<Box mr={3} width={300}>
								<Autocomplete
									key={`${values.locationId}-wc`}
									disableClearable
									renderInput={(params) => (
										<MUITextField
											{...params}
											variant='filled'
											label={t("workers_work-center")}
											InputLabelProps={{
												shrink: true,
											}}
										/>
									)}
									value={getSelectedWorkcenter() ?? undefined}
									options={locationWorkcenters ?? []}
									getOptionLabel={(
										option:
											| {
													id: string | number;
													name: string;
											  }
											| undefined
									) => {
										if (option) {
											return option.name;
										} else {
											return "";
										}
									}}
									onChange={(_event, value) => {
										if (value) {
											setFieldValue("workCenterId", value.id, true);
											setFieldValue("primaryJobId", 0);
										}
									}}
									renderOption={(props, option, { inputValue }) => {
										if (
											option &&
											Object.prototype.hasOwnProperty.call(option, "id")
										) {
											return (
												<li {...props} key={option.id}>
													<Box
														sx={{
															display: "flex",
															flexDirection: "row",
															alignItems: "center",
															justifyContent: "flex-start",
															minHeight: "32px",
														}}
													>
														<Typography
															sx={{
																fontFamily: "Roboto",
																fontSize: "14px !important",
																color: "rgba(0,0,0,0.87) !important",
																lineHeight: "20px !important",
																fontWeight: 400,
															}}
														>
															<Highlight
																value={option.name ?? ""}
																searchText={inputValue}
															/>
														</Typography>
													</Box>
												</li>
											);
										} else {
											return <></>;
										}
									}}
								/>
							</Box>
						)}
					</Box>
					<Box
						display='flex'
						justifyContent='flex-start'
						flexWrap='wrap'
						mt={2}
						sx={{
							minHeight: "80px",
						}}
					>
						<Box mr={3} width={300}>
							<LocalizationProvider dateAdapter={AdapterDateFns}>
								<DatePicker
									value={values.joiningDate ? parseISO(values.joiningDate) : null}
									onChange={(newValue: any) => {
										try {
											if (newValue === null) {
												setFieldValue("joiningDate", null);
												setFieldTouched("joiningDate", true);
												return;
											}
											if (dateFns.isValid(newValue)) {
												const formatted = dateFns.format(newValue, "uuuu-MM-dd");
												setFieldValue(
													"joiningDate",
													formatted
												);
											} else {
												// Propagate invalid date to Formik so Yup can show error
												setFieldValue("joiningDate", "invalid");
											}
											setFieldTouched("joiningDate", true);
										} catch (e) {
											// Do nothing
										}
									}}
									name='joiningDate'
									minDate={parseISO("0000-01-01")}
									slotProps={{
										//   field: { clearable: true },
										textField: {
											placeholder: t("workers_select-date"),
											variant: "filled",
											helperText:
												errors.joiningDate ??
												t("workers_date-considered-for-seniority"),
											error: !!errors.joiningDate,
										},
									}}
									format={"MM/dd/yyyy"}
									sx={{ width: "100%" }}
									label={t("workers_joining-date")}
								/>
							</LocalizationProvider>
						</Box>
						<Box mr={3} width={300}>
							<FormControl variant='filled' className={classes.formControlRoot}>
								{!isEditing ? (
									<Field
										variant='filled'
										component={TextField}
										name='companyEmployeeId'
										id='companyEmployeeId'
										label={t("workers_worker-id")}
										sx={{
											minHeight: "80px",
										}}
										InputLabelProps={{
											shrink: true,
										}}
										inputProps={{
											maxLength: 20,
											onKeyPress: (event: {
												key: string;
												preventDefault: () => void;
											}) => {
												if (event.key === " ") {
													event.preventDefault();
												}
											},
										}}
									/>
								) : (
									<Field
										variant='filled'
										component={TextField}
										name='companyEmployeeId'
										id='companyEmployeeId'
										label={t("workers_worker-id")}
										sx={{
											minHeight: "80px",
										}}
										InputLabelProps={{
											shrink: true,
										}}
										inputProps={{
											maxLength: 20,
											onKeyPress: (event: {
												key: string;
												preventDefault: () => void;
											}) => {
												if (event.key === " ") {
													event.preventDefault();
												}
											},
										}}
										onChange={(e: any) => {
											if (
												isEmployeeIdUniqueData.originalEmployeeId !==
												e.target.value
											) {
												dispatch(
													setIsEmployeeIdUnique({
														originalEmployeeId:
															isEmployeeIdUniqueData.originalEmployeeId,
														employeeId: e.target.value,
														isUnique: false,
														checked: false,
													})
												);
											} else {
												dispatch(
													setIsEmployeeIdUnique({
														originalEmployeeId:
															isEmployeeIdUniqueData.originalEmployeeId,
														employeeId: e.target.value,
														isUnique: true,
														checked: true,
													})
												);
											}
											setFieldValue("companyEmployeeId", e.target.value);
										}}
										InputProps={{
											endAdornment: getWorkerIdEndAdornment(),
										}}
										error={
											getWorkerIdError() ||
											!(
												getWorkerIdHelperText() === WORKER_ID_AVAILABLE ||
												getWorkerIdHelperText() === ""
											)
										}
										helperText={getWorkerIdHelperText()}
									/>
								)}
							</FormControl>
						</Box>
					</Box>
					<Box
						display='flex'
						justifyContent='flex-start'
						flexWrap='wrap'
						mt={2}
						sx={{
							minHeight: "80px",
						}}
					>
						<Box mr={3} width={300}>
							<FormControl variant='filled' className={classes.formControlRoot}>
								<Field
									variant='filled'
									component={TextField}
									name='jobTitle'
									id='jobTitle'
									label={t("workers_job-title-optional")}
									InputLabelProps={{
										shrink: true,
									}}
									inputProps={{
										maxLength: 100,
									}}
								/>
							</FormControl>
						</Box>
						{allJobRoles && (
							<Box mr={3} width={300}>
								<Autocomplete
									renderInput={(params) => (
										<MUITextField
											{...params}
											variant='filled'
											label={t("workers_primary-job-optional")}
											InputLabelProps={{
												shrink: true,
											}}
											InputProps={{
												...params.InputProps,
												startAdornment: values.primaryJobId !== 0 &&
													values.primaryJobHexColor && (
														<JobColor
															color={`#${values.primaryJobHexColor ?? ""}`}
														/>
													),
											}}
										/>
									)}
									value={getSelectedJobRole()}
									options={
										getJobsByWorkCenter(values?.workCenterId) ?? undefined
									}
									getOptionLabel={(
										option: any
										// | {
										//     id: string | number;
										//     name: string;
										//     hexColor: string;
										//   }
										// | undefined
									) => {
										if (option) {
											return option.name;
										} else {
											return "";
										}
									}}
									onChange={(_event, value) => {
										if (value) {
											setFieldValue("primaryJobId", value.id);
											setFieldValue("primaryJobHexColor", value.hexColor);
										} else {
											setFieldValue("primaryJobId", 0);
											setFieldValue("primaryJobHexColor", null);
										}
									}}
									renderOption={(props, option, { inputValue }) => {
										if (
											option &&
											Object.prototype.hasOwnProperty.call(option, "id")
										) {
											return (
												<li {...props} key={option.id}>
													<Box
														sx={{
															display: "flex",
															flexDirection: "row",
															alignItems: "center",
															justifyContent: "flex-start",
															minHeight: "32px",
															gap: 1,
														}}
													>
														<JobColor color={`#${option.hexColor}`} />
														<Typography
															sx={{
																fontFamily: "Roboto",
																fontSize: "14px !important",
																color: "rgba(0,0,0,0.87) !important",
																lineHeight: "20px !important",
																fontWeight: 400,
															}}
														>
															<Highlight
																value={option.name ?? ""}
																searchText={inputValue}
															/>
														</Typography>
													</Box>
												</li>
											);
										} else {
											return <></>;
										}
									}}
								/>
							</Box>
						)}
					</Box>
					<Box
						display='flex'
						justifyContent='flex-start'
						flexWrap='wrap'
						mt={2}
						sx={{
							minHeight: "80px",
						}}
					>
						{workerTypes && (
							<Box minWidth={300} mr={3}>
								<FormControl
									variant='filled'
									className={classes.formControlRoot}
								>
									<Field
										component={TextField}
										select
										name='type'
										label={t("workers_worker-type")}
										value={values.workerTypeId || ""}
										onChange={(e: { target: { value: string } }) => {
											setFieldValue("workerTypeId", e.target.value);
											setFieldValue(
												"workerTypeName",
												getWorkerType(parseInt(e.target.value)).name
											);
											setFieldValue(
												"workerTypeText",
												getWorkerType(parseInt(e.target.value)).text
											);
											// Reset shift pattern if worker type is not Full time
											if (getWorkerType(e.target.value).name === "FlexWorker") {
												setFieldValue("shiftPatternId", 0);
											}
											// Reset worker sub type
											if (isWorkerSubTypeEnabled) {
												setFieldValue("workerSubTypeId", "");
												setFieldTouched("workerSubTypeId", true, true);
											}
										}}
										variant='filled'
									>
										{workerTypes.map((type) => (
											<MenuItem key={`worker-type-${type.id}`} value={type.id}>
												{type.text ?? deCamelCase(type.name)}
											</MenuItem>
										))}
									</Field>
								</FormControl>
							</Box>
						)}
						{/* TODO: Remove this once the worker sub type is added to the API */}
						{isWorkerSubTypeEnabled && (
							<Box width={300} alignItems='center'>
								<Autocomplete<WorkerSubType, false>
									options={
										combinedWorkerTypes.find(
											(type: { id: number }) =>
												type.id === parseInt(values.workerTypeId)
										)?.subtypes || []
									}
									getOptionLabel={(option: WorkerSubType) => option.name}
									value={
										combinedWorkerTypes
											.find(
												(type: { id: number }) =>
													type.id === parseInt(values.workerTypeId)
											)
											?.subtypes?.find(
												(subtype: { id: number }) =>
													subtype.id === values.workerSubTypeId
											) || null
									}
									onChange={(_, newValue) => {
										setFieldValue("workerSubTypeId", newValue?.id || "");
									}}
									renderInput={(params) => (
										<MUITextField
											{...params}
											variant='filled'
											label={t("workers_worker-sub-type")}
											InputLabelProps={{
												shrink: true,
											}}
										/>
									)}
								/>
							</Box>
						)}
					</Box>
					<Box
						display='flex'
						justifyContent='flex-start'
						flexWrap='wrap'
						mt={2}
						sx={{
							minHeight: "80px",
						}}
					>
						{workerTypes && (
							<Box minWidth={300} mr={3}>
								<FormControl
									variant='filled'
									className={classes.formControlRoot}
								>
									<Field
										component={TextField}
										select
										name='workerStatusId'
										label={t("workers_worker-status")}
										value={values.workerStatusId || ""}
										onChange={(e: { target: { value: string } }) => {
											setFieldValue("workerStatusId", e.target.value);
										}}
										variant='filled'
										helperText=' '
										fullWidth
										SelectProps={{
											MenuProps: {
												//disableScrollLock: true,
												PaperProps: {
													style: {
														maxHeight: ITEM_HEIGHT * 5 - ITEM_PADDING_TOP,
														width: 250,
													},
												},
												anchorOrigin: {
													vertical:
														position && position.y > 800 ? "top" : "bottom",
													horizontal: "left",
												},
												transformOrigin: {
													vertical:
														position && position.y > 800 ? "bottom" : "top",
													horizontal: "left",
												},
											},
										}}
									>
										{isEditing
											? workerStatuses
													.find(
														(type: { workerStatusId: number }) =>
															type.workerStatusId === values.workerStatusId
													)
													?.transitions.map(
														(transition: {
															workerStatusId: number;
															toStatus: { name: string };
														}) => (
															<MenuItem
																key={`worker-type-${transition.workerStatusId}`}
																value={transition.workerStatusId}
															>
																{transition.toStatus?.name ||
																	deCamelCase(transition.toStatus?.name || "")}
															</MenuItem>
														)
													)
											: workerStatuses.map(
													(ws: { workerStatusId: number; name: string }) => (
														<MenuItem
															key={`worker-type-${ws.workerStatusId}`}
															value={ws.workerStatusId}
														>
															{ws.name || deCamelCase(ws.name || "")}
														</MenuItem>
													)
											  )}
									</Field>
								</FormControl>
							</Box>
						)}
						{companySupervisors && (
							<Box mr={3} width={300}>
								<Autocomplete
									disableClearable
									renderInput={(params) => (
										<MUITextField
											{...params}
											variant='filled'
											label={t("workers_reporting-manager")}
											InputLabelProps={{
												shrink: true,
											}}
										/>
									)}
									value={getSelectedSupervisor() ?? undefined}
									options={companySupervisors}
									getOptionLabel={(option: Supervisor | undefined) => {
										if (option) {
											const firstName = option.firstName ?? "";
											const lastName = option.lastName ?? "";
											return firstName + " " + lastName;
										} else {
											return "";
										}
									}}
									onChange={(_event, value: Supervisor | undefined) => {
										if (value) {
											setFieldValue("managerUserId", value.id);
										}
									}}
									renderOption={(
										props,
										option: Supervisor | undefined,
										{ inputValue }
									) => {
										if (option) {
											const id = option.id ?? "worker-id";
											return (
												<li {...props} key={id}>
													<Box
														sx={{
															display: "flex",
															flexDirection: "row",
															alignItems: "center",
															justifyContent: "flex-start",
															minHeight: "32px",
														}}
													>
														<Typography
															sx={{
																fontFamily: "Roboto",
																fontSize: "14px !important",
																color: "rgba(0,0,0,0.87) !important",
																lineHeight: "20px !important",
																fontWeight: 400,
															}}
														>
															<Highlight
																value={option.firstName + " " + option.lastName}
																searchText={inputValue}
															/>
														</Typography>
													</Box>
												</li>
											);
										} else {
											return <></>;
										}
									}}
								/>
							</Box>
						)}
					</Box>
					{getLocationShiftPatternStatus === "pending" &&
					getWorkerType(values.workerTypeId).name === "FullTime" ? (
						<Box
							display='flex'
							justifyContent='flex-start'
							flexWrap='wrap'
							mt={2}
							sx={{
								minHeight: "80px",
							}}
						>
							<Box width={300} mt={2} ml={3} alignItems='center'>
								<CircularProgress size={20} />
							</Box>
						</Box>
					) : getWorkerType(values.workerTypeId).name === "FullTime" &&
					  getLocationShiftPatternStatus === "fulfilled" ? (
						<Box
							display='flex'
							justifyContent='flex-start'
							flexWrap='wrap'
							mt={2}
							sx={{
								minHeight: "80px",
							}}
						>
							<Box display='flex' justifyContent='flex-start' flexWrap='wrap'>
								<Box width={300}>
									<FormControl
										variant='filled'
										className={classes.formControlRoot}
										ref={myElementRef}
									>
										<Field
											component={TextField}
											type='text'
											select
											variant='filled'
											name='shiftPatternId'
											id='shiftPatternId'
											label={t("workers_shift-pattern-optional")}
											value={
												values.shiftPatternId === 0 ? "" : values.shiftPatternId
											}
											onChange={(e: { target: { value: any } }) => {
												setFieldValue("shiftPatternId", e.target.value);

												const locationShiftPattern =
													locationShiftPatterns?.find(
														(lsp: { id: any }) => lsp.id === e.target.value
													);
												if (locationShiftPattern)
													setSelectedShiftPattern(locationShiftPattern);
												else setSelectedShiftPattern({});
											}}
											helperText=' '
											fullWidth
											SelectProps={{
												MenuProps: {
													//disableScrollLock: true,
													PaperProps: {
														style: {
															maxHeight: ITEM_HEIGHT * 5 - ITEM_PADDING_TOP,
															width: 250,
														},
													},
													anchorOrigin: {
														vertical:
															position && position.y > 400 ? "top" : "bottom",
														horizontal: "left",
													},
													transformOrigin: {
														vertical:
															position && position.y > 400 ? "bottom" : "top",
														horizontal: "left",
													},
													getContentAnchorEl: null,
												},
											}}
										>
											{getLocationShiftPatternStatus === "pending" ? (
												<MenuItem disabled>
													<CircularProgress size={20} />
												</MenuItem>
											) : locationShiftPatterns.length > 0 ? (
												locationShiftPatterns.map(
													(lsp: {
														id: string | undefined;
														name:
															| boolean
															| React.ReactChild
															| React.ReactFragment
															| React.ReactPortal
															| null
															| undefined;
													}) => (
														<MenuItem value={lsp.id} key={lsp.id} id={lsp.id}>
															{lsp.name}
														</MenuItem>
													)
												)
											) : (
												<MenuItem disabled>
													<Typography color='black'>
														{t("workers_no-shift-patterns-found")}
													</Typography>
												</MenuItem>
											)}
										</Field>
									</FormControl>
								</Box>
								<Box
									width={300}
									ml={3}
									sx={{
										display: "flex",
										alignItems: "center",
										justifyContent: "flex-start",
										paddingBottom: "17px",
									}}
								>
									<Button
										disabled={
											values?.shiftPatternId === 0 ||
											typeof selectedShiftPattern !== "object" ||
											(typeof selectedShiftPattern === "object" &&
												Object.keys(selectedShiftPattern).length === 0)
										}
										onClick={openShiftPattern}
									>
										{t("workers_view-shift-pattern-details")}
									</Button>
									{isEditing && (
										<>
											{workerProfile?.pendingPatternChange ? (
												<Box
													sx={{
														backgroundColor: "#e3f2fd",
														borderRadius: "4px",
														px: 1.5,
														py: 0.5,
														display: "flex",
														alignItems: "center",
														gap: 1,
														border: "1px solid #90caf9",
														ml: 2,
													}}
												>
													<Typography
														variant="caption"
														sx={{ fontWeight: "bold", color: "#1976d2" }}
													>
														{t("workers_pending-pattern-change", {
															name: workerProfile.pendingPatternChange
																.shiftPatternName,
															date: formatDate({
																dateStr:
																	workerProfile.pendingPatternChange
																		.effectiveDate,
																formatType: "NUMERIC_DATE",
																ISOString: false,
															}),
														})}
													</Typography>
															{canEditWorker && (
														<Tooltip title={t("workers_cancel-pending-change")}>
															<IconButton
																size="small"
																onClick={handleCancelPatternChange}
																disabled={
																	cancelFuturePatternChangeStatus === "pending"
																}
																sx={{ p: 0 }}
															>
																{cancelFuturePatternChangeStatus === "pending" ? (
																	<CircularProgress size={14} />
																) : (
																	<CloseIcon
																		sx={{ fontSize: 16, color: "#d32f2f" }}
																	/>
																)}
															</IconButton>
														</Tooltip>
													)}
												</Box>
											) : (
												<Button
													onClick={openSchedulePatternChange}
													sx={{ ml: 2, textTransform: "none" }}
													variant="outlined"
												>
													{t("workers_schedule-pattern-change")}
												</Button>
											)}
										</>
									)}
								</Box>
							</Box>
						</Box>
					) : null}
					{/* Badge Number */}
					{badgeNumberEnabled &&
						badgeNumberEnabledLocations?.includes(values.locationId) && (
							<Box
								display='flex'
								justifyContent='flex-start'
								flexWrap='wrap'
								mt={2}
								sx={{
									minHeight: "80px",
								}}
							>
								<Box mr={3} width={300}>
									<FormControl
										variant='filled'
										className={classes.formControlRoot}
									>
										<Field
											variant='filled'
											component={TextField}
											name='badgeNumber'
											id='badgeNumber'
											label={t("workers_badge-number")}
											type='text'
											sx={{
												minHeight: "80px",
											}}
											InputLabelProps={{
												shrink: true,
											}}
											inputProps={{
												maxLength: 18,
												onKeyPress: (event: {
													key: string;
													preventDefault: () => void;
												}) => {
													if (
														event.key === " " ||
														!isNumber.test(event.key)
													) {
														event.preventDefault();
													}
												},
											}}
											{...(isEditing && {
												onChange: (e: any) => {
													if (
														isBadgeNumberUniqueData.originalBadgeNumber !==
														e.target.value
													) {
														dispatch(
															setIsBadgeNumberUnique({
																originalBadgeNumber:
																	isBadgeNumberUniqueData.originalBadgeNumber,
																badgeNumber: e.target.value,
																isUnique: false,
																checked: false,
															})
														);
													} else {
														dispatch(
															setIsBadgeNumberUnique({
																originalBadgeNumber:
																	isBadgeNumberUniqueData.originalBadgeNumber,
																badgeNumber: e.target.value,
																isUnique: true,
																checked: true,
															})
														);
													}
													setFieldValue("badgeNumber", e.target.value);
												},
												InputProps: {
													endAdornment: getBadgeNumberEndAdornment(),
												},
												error:
													getBadgeNumberError() ||
													!(
														getBadgeNumberHelperText() ===
															BADGE_NUMBER_AVAILABLE ||
														getBadgeNumberHelperText() === ""
													),
 											helperText: getBadgeNumberHelperText(),
											})}
										/>
									</FormControl>
								</Box>
							</Box>
						)}
					{isActive ? (
						<Box
							display='flex'
							alignItems='center'
							justifyContent='space-between'
						>
							<Box m={0}>
								{(createNewWorkerStatus === "error" ||
									editWorkerStatus === "error") && (
									<Alert severity='error'>
										<AlertTitle>{t("workers_error")}</AlertTitle>
										<strong>
											{createNewWorkerErrorMessage || editWorkerErrorMessage}
										</strong>
									</Alert>
								)}
							</Box>
							<Box display='flex' alignItems='center' justifyContent='flex-end'>
								<Box m={1}>
									<Button
										onClick={() => {
											isEditing
												? setActiveStep(0)
												: dispatch(closeAddWorkerDialog());
										}}
									>
										{t("common_cancel")}
									</Button>
								</Box>
								<Box m={1}>
									{/* <Button
									variant='contained'
									onClick={handleNext}
									disabled={
										!isValid ||
										!values.firstName ||
										!values.lastName ||
										!values.joiningDate ||
										!values.managerUserId ||
										checkWorkerIdAlreadyExists(values.companyEmployeeId)
									}
								>
									Next
								</Button> */}

									<Button
										style={{ textTransform: "none", fontWeight: "bold" }}
										variant='contained'
										color='primary'
										type='submit'
										startIcon={
											isSubmitting ? <CircularProgress size={20} /> : undefined
										}
										disabled={
											isEmployeeIdUniqueStatus === "pending" ||
											isBadgeNumberUniqueStatus === "pending" ||
											isSubmitting ||
											!values.joiningDate ||
											errors.joiningDate ||
											!values.managerUserId ||
											!values.workCenterId ||
											(isEditing &&
												((isEmployeeIdUniqueData?.employeeId ===
													values.companyEmployeeId &&
													isEmployeeIdUniqueData?.isUnique === false &&
													isEmployeeIdUniqueData?.checked === true) ||
													isEmployeeIdUniqueData?.checked === false)) ||
											(isEditing &&
												((isBadgeNumberUniqueData?.badgeNumber ===
													values.badgeNumber &&
													isBadgeNumberUniqueData?.isUnique === false &&
													isBadgeNumberUniqueData?.checked === true) ||
													isBadgeNumberUniqueData?.checked === false)) ||
											(isWorkerSubTypeEnabled &&
												(!values.workerSubTypeId ||
													values.workerSubTypeId === "" ||
													values.workerSubTypeId === 0))
										}
										//onClick={() => dispatch(resetWorkerDetails())}
									>
										{isSubmitting
											? isEditing
												? t("workers_saving")
												: t("workers_adding-worker")
											: isEditing
											? t("workers_save")
											: t("workers_add")}
									</Button>
								</Box>
							</Box>
						</Box>
					) : null}
				</Box>
				<ShiftPatternDialog
					open={isShiftPatternOpen}
					handleClose={closeShiftPattern}
					shiftPattern={selectedShiftPattern}
					locationId={values.locationId}
				/>
				<SchedulePatternChangeDialog
					open={isSchedulePatternChangeOpen}
					handleClose={closeSchedulePatternChange}
					workerId={values.workerId}
					currentShiftPatternId={values.shiftPatternId}
					locationShiftPatterns={locationShiftPatterns}
				/>
				<ConfirmDialog
					open={isPendingScheduleConfirmOpen}
					onClose={() => setIsPendingScheduleConfirmOpen(false)}
					title={t("workers_pending-schedule-request")}
					text={pendingScheduleConfirmText}
					loading={cancelFuturePatternChangeStatus === "pending"}
					action={handleCancelPatternChange}
				/>
			</Box>
		);
	}
);

export default WorkerDetailForm;
